export enum Habilitation {
  Doctor = 'doctor',
  ChiefPhysician = 'chief_physician',
  PrivateDocent = 'private_docent',
  SeniorPhysician = 'senior_physician',
  Professor = 'professor',
}

export const HABILITATION_I18N = {
  [Habilitation.Doctor]: 'Dr.',
  [Habilitation.Professor]: 'Prof. Dr.',
  [Habilitation.PrivateDocent]: 'PD Dr.',
  [Habilitation.SeniorPhysician]: 'OA Dr.',
  [Habilitation.ChiefPhysician]: 'CA Dr.',
};
